import { RootState } from 'editor/src/store/index';

const isLockElementsAllowed = (state: RootState) => state.hostSettings.allowLockElements;

export default isLockElementsAllowed;
